<template>
  <div>
    <el-form
      ref="form"
      label-width="130px"
      :hide-required-asterisk="false"
      :rules="rules"
      :model="form"
    >
      <el-row>
        <el-col><div class="label">时间安排</div></el-col>
        <el-col :span="24">
          <el-form-item label="开始时间：" prop="startTime">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              v-model="form.startTime"
              :picker-options="pickerOptionsStart"
              :clearable="false"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间：" prop="endTime">
            <el-date-picker
              type="date"
              placeholder="选择日期"
              :picker-options="pickerOptionsEnd"
              :clearable="false"
              v-model="form.endTime"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col><div class="label">任务</div></el-col>
        <el-col>
          <el-form-item label="课题承担任务：" prop="taskContent">
            <el-input
              type="textarea"
              show-word-limit
              rows="4"
              placeholder="请输入课题承担任务"
              maxlength="200"
              v-model="form.taskContent"
            ></el-input>
          </el-form-item>
          <el-form-item label="完成进度(%)：" prop="progress">
            <el-input-number
              v-model="form.progress"
              :min="0"
              :max="100"
              class="reward-input"
            ></el-input-number>
          </el-form-item>
          <el-form-item label="备注：" prop="remark">
            <el-input
              v-model="form.remark"
              type="textarea"
              show-word-limit
              rows="4"
              placeholder="备注"
              maxlength="200"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { editSituation } from "@/api/course.js";
import moment from "moment";
export default {
  props: ["mxParams", "editForm"],
  data() {
    return {
      form: {
        startTime: null,
        endTime: null,
        taskContent: null,
        progress: null,
        remark: null,
      },
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.form.endTime) {
            return (
              time.getTime() > new Date(this.form.endTime).getTime() ||
              time.getTime() <
                new Date(this.form.endTime).getTime() - 1000 * 60 * 60 * 24 * 90
            );
          }
        },
      },
      // 结束日期限制
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.form.startTime) {
            return (
              time.getTime() < new Date(this.form.startTime).getTime() ||
              time.getTime() >
                new Date(this.form.startTime).getTime() +
                  1000 * 60 * 60 * 24 * 90
            );
          }
        },
      },
      rules: {
        startTime: [
          { required: true, message: "开始时间不能为空", trigger: "blur" },
        ],
        endTime: [
          { required: true, message: "结束时间不能为空", trigger: "blur" },
        ],
        taskContent: [
          { required: true, message: "课题承担任务不能为空", trigger: "blur" },
        ],
        progress: [
          { required: true, message: "完成进度不能为空", trigger: "change" },
        ],
      },
    };
  },
  created() {
    const { id, startTime, endTime, taskContent, progress, remark } =
      this.editForm;
    this.form = {
      id,
      startTime: moment(startTime),
      endTime: moment(endTime),
      taskContent,
      progress: parseInt(progress),
      remark,
    };
  },
  methods: {
    save() {
      const { endTime, startTime, progress } = this.form;
      editSituation({
        ...this.form,
        startTime: moment(startTime).format("YYYYMMDD"),
        endTime: moment(endTime).format("YYYYMMDD"),
        progress: progress + "%",
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.$emit("getParentForm");
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.label {
  font-size: 16px;
  font-weight: 700;
  line-height: 44px;
}
</style>